"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreOrderHistoryService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("../../shared/services/restservice");
class PreOrderHistoryService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.preOrderHistoryUrl = '/rest-api/account/order/v1/history/preOrderHistory/list';
    }
    getPreOrderHistoryDetails() {
        return this.get(this.preOrderHistoryUrl).pipe(operators_1.map((data) => data));
    }
}
exports.PreOrderHistoryService = PreOrderHistoryService;
//# sourceMappingURL=preorderhistory.service.js.map